class EntryModal extends DetailsModal {
  constructor() {
    super();
    
    this.sectionId = this.getAttribute('data-section-id') || null;
    this.form = this.querySelector('form');
    this.detailsElement = this.querySelector('details');
    this.formView = this.querySelector('[data-view="form"]');
    this.successView = this.querySelector('[data-view="success"]');

    if (this.form) {
      this.form.addEventListener('submit', (e) => {
        e.preventDefault();
        this.showLoadingState();
        this.markAsCompletedPermanently();
        
        setTimeout(() => {
          this.form.submit();
        }, 10000);
      });
    }

    this.originalClose = this.close.bind(this);
    const closeButton = this.querySelector('button[type="button"][aria-label="Fechar modal"]');
    if (closeButton) {
      closeButton.removeEventListener('click', this.originalClose);
      closeButton.addEventListener('click', () => {
        this.markAsClosedThisSession();
        this.close(false);
      });
    }

    const successCloseButton = this.querySelector('[data-view="success"] .ec-entry-modal__success-button');
    if (successCloseButton) {
      successCloseButton.addEventListener('click', () => {
        this.close(false);
      });
    }

    const couponCopyButton = this.querySelector('.ec-entry-modal__success-coupon-copy');
    if (couponCopyButton) {
      couponCopyButton.addEventListener('click', () => {
        const couponText = this.querySelector('.ec-entry-modal__success-coupon-text');
        if (couponText) {
          navigator.clipboard.writeText(couponText.textContent).then(() => {
            couponCopyButton.classList.add('copied');
            setTimeout(() => {
              couponCopyButton.classList.remove('copied');
            }, 2000);
          });
        }
      });
    }
  }

  initializeModal(sectionId) {
    this.sectionId = sectionId;

    const completedKey = `EC_ENTRY_MODAL_COMPLETED_${sectionId}`;
    const wasCompleted = this.getLocalStorage(completedKey);
    
    const viewedSuccessKey = `EC_SUCCESS_VIEWED_${sectionId}`;
    const successAlreadyViewed = this.getLocalStorage(viewedSuccessKey);

    if (wasCompleted && !successAlreadyViewed) {
      this.showSuccessView();
      setTimeout(() => {
        this.open({ target: this.detailsElement });
      }, 500);
      return;
    }

    if (wasCompleted && successAlreadyViewed) {
      this.detailsElement.removeAttribute('open');
      
      this.open = () => {
        if (this.detailsElement.hasAttribute('open')) {
          this.detailsElement.removeAttribute('open');
        }
      };
      
      const summary = this.querySelector('summary');
      if (summary) {
        summary.style.pointerEvents = 'none';
        summary.style.cursor = 'not-allowed';
        summary.setAttribute('aria-disabled', 'true');
      }
      
      return;
    }

    const closedKey = `EC_ENTRY_MODAL_CLOSED_${sectionId}`;
    const wasClosedThisSession = this.getSessionStorage(closedKey);

    if (wasClosedThisSession) {
      return;
    }

    setTimeout(() => {
      this.open({ target: this.detailsElement });
    }, 500);
  }

  markAsCompletedPermanently() {
    if (this.sectionId) {
      const completedKey = `EC_ENTRY_MODAL_COMPLETED_${this.sectionId}`;
      this.setLocalStorage(completedKey, '1');
    }
  }

  showSuccessView() {
    if (this.formView && this.successView) {
      this.formView.style.display = 'none';
      this.successView.style.display = 'flex';
      
      if (this.sectionId) {
        const viewedSuccessKey = `EC_SUCCESS_VIEWED_${this.sectionId}`;
        this.setLocalStorage(viewedSuccessKey, '1');
      }
    }
  }

  showLoadingState() {
    if (!this.form) {
      return;
    }
    
    this.stopCompletionObserver();
    
    this.form.classList.add('is-loading');
    
    const submitButton = this.form.querySelector('button[type="submit"]');
    if (submitButton) {
      submitButton.classList.add('is-loading');
      
      const buttonText = submitButton.querySelector('.ec-entry-modal__button-text');
      
      if (buttonText) {
        const spinner = document.createElement('div');
        spinner.className = 'ec-entry-modal__spinner';
        submitButton.prepend(spinner);
      }
    }
  }

  open(event) {
    super.open(event);
    this.startCompletionObserver();
  }

  close(focusToggle = true) {
    this.stopCompletionObserver();
    super.close(focusToggle);
  }

  onBodyClick(event) {
    const lgpdOverlay = document.getElementById('ec-lgpd-overlay');
    const lgpdModal = document.getElementById('ec-lgpd-modal');
    if ((lgpdOverlay && lgpdOverlay.contains(event.target)) ||
        (lgpdModal && lgpdModal.contains(event.target))) {
      return;
    }
    super.onBodyClick(event);
  }

  markAsClosedThisSession() {
    if (this.sectionId) {
      const closedKey = `EC_ENTRY_MODAL_CLOSED_${this.sectionId}`;
      this.setSessionStorage(closedKey, '1');
    }
  }

  setSessionStorage(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (e) {
      console.warn('SessionStorage not available:', e);
    }
  }

  getSessionStorage(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (e) {
      console.warn('SessionStorage not available:', e);
      return null;
    }
  }

  setLocalStorage(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (e) {
      console.warn('LocalStorage not available:', e);
    }
  }

  getLocalStorage(key) {
    try {
      return localStorage.getItem(key);
    } catch (e) {
      console.warn('LocalStorage not available:', e);
      return null;
    }
  }

  startCompletionObserver() {
    this.observer = setInterval(() => {
      if (this.sectionId) {
        const completedKey = `EC_ENTRY_MODAL_COMPLETED_${this.sectionId}`;
        const wasCompleted = this.getLocalStorage(completedKey);
        
        if (wasCompleted && this.isOpen()) {
          this.showSuccessView();
          clearInterval(this.observer);
        }
      }
    }, 100);
  }

  stopCompletionObserver() {
    if (this.observer) {
      clearInterval(this.observer);
    }
  }
}

customElements.define('ec-entry-modal', EntryModal);
